import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://oneharvestco.com";
const SITE_NAME = "OneHarvest";
const DEFAULT_TITLE = "OneHarvest | Environmental Risk Management & Jobsite Solutions";
const DEFAULT_DESCRIPTION =
  "OneHarvest LLC delivers best-in-class environmental risk management and jobsite solutions — industrial absorbents, water treatment, ground protection matting, and spill response for oil & gas, pipeline, and heavy construction operations nationwide.";
const DEFAULT_IMAGE = `${SITE_URL}/og-share.jpg`;

export function Seo({ title, description, image, type = "website", noindex = false, jsonLd }) {
  const { pathname } = useLocation();
  const canonical = `${SITE_URL}${pathname}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const img = (image && image.startsWith("/") ? `${SITE_URL}${image}` : image) || DEFAULT_IMAGE;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export default Seo;
